import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateGcWASettingForm } from '../../../../actions/waitingArea.js';
import { Checkbox } from 'semantic-ui-react';
import objectAssign from 'object-assign';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

const CenterPanelUpdate = ({ isAdmin, setSaveButtonDisableClass }) => {
  const dispatch = useDispatch();
  let htmlToReactParser = new HtmlToReact.Parser(React);
  const gcWaitingAreaSettings = useSelector((state) => state.waitingAreaReducer.gcWaitingAreaSettings);
  const gcWaitngAreaSettingForm = useSelector((state) => state.waitingAreaReducer.gcWaitngAreaSettingForm);

  const gcWAFormSettingUpdated = (property, value) => {
    let updatedGcSettingForm = objectAssign({}, gcWaitngAreaSettingForm, { [property]: value });
    return updatedGcSettingForm;
  };

  const handleChatToggle = (event, data) => {
    if (gcWaitingAreaSettings?.isChatEditable || gcWaitingAreaSettings?.isOUChatEnabled) {
      setSaveButtonDisableClass('');
      dispatch(updateGcWASettingForm(gcWAFormSettingUpdated('isChatEnabled', !gcWaitngAreaSettingForm.isChatEnabled)));
    }
  };
  const handleFullNameToggle = (event, data) => {
    if (gcWaitingAreaSettings?.isCallerFullNameEditable || gcWaitingAreaSettings?.isOUFullNameEnabled) {
      setSaveButtonDisableClass('');
      dispatch(
        updateGcWASettingForm(
          gcWAFormSettingUpdated('isCallerFullNameEnabled', !gcWaitngAreaSettingForm.isCallerFullNameEnabled)
        )
      );
    }
  };

  return (
    <div className={isAdmin == true ? 'form minHeightLargerForm' : 'form'}>
      {gcWaitingAreaSettings?.isPortalChatEnabled && (
        <>
          <Checkbox
            tabIndex="1"
            className="mrbs"
            label={APP.LANGUAGE.GCSettings.ChatToggleTitle}
            checked={gcWaitngAreaSettingForm?.isChatEnabled}
            onClick={handleChatToggle}
            readOnly={!gcWaitingAreaSettings?.isChatEditable || !gcWaitingAreaSettings?.isOUChatEnabled ? true : false}
          />
          <div className="checkbox-desc mrbs">{APP.LANGUAGE.GCSettings.ChatToggleDesc}</div>
        </>
      )}
      {gcWaitingAreaSettings?.isPortalCallerFullNameEnabled && (
        <>
          <Checkbox
            tabIndex="2"
            className="mrbs"
            label={APP.LANGUAGE.GCSettings.FullNameToggleTitle}
            onClick={handleFullNameToggle}
            checked={gcWaitngAreaSettingForm?.isCallerFullNameEnabled}
            readOnly={
              !gcWaitingAreaSettings?.isCallerFullNameEditable || !gcWaitingAreaSettings?.isOUFullNameEnabled
                ? true
                : false
            }
          />
          <div className="checkbox-desc mrbs">{APP.LANGUAGE.GCSettings.FullNameToggleDesc}</div>
        </>
      )}
    </div>
  );
};

export default CenterPanelUpdate;
